import React from 'react';
import { useRouter } from 'next/router';
import { Tab, Tabs } from '@mui/material';
import { useGNBEventTracker } from '@/hooks/gtm/useGTMEventTracker';
import { GNBEventName } from '@/constant/gtm';

export type Tab = {
  label: string;
  value: string;
  selectedPath: RegExp[];
};

export type GNBTabProps = {
  tabs?: Tab[];
  defaultTab?: string;
};

const GNBTab = (props: GNBTabProps) => {
  const { tabs = [], defaultTab = '' } = props;
  const gnbEventTracker = useGNBEventTracker();
  const router = useRouter();
  const { pathname, query } = router;

  /** 현재 활성 탭 계산 */
  const activeTab = tabs.findIndex(({ value, selectedPath }) => {
    const matchesPath = selectedPath.some((regex) => regex.test(pathname));

    const isActive =
      pathname === '/' && ((query.tab as string) ?? defaultTab) === value;

    return matchesPath || isActive;
  });

  const onClickTab = (tab: (typeof tabs)[number]) => {
    gnbEventTracker(GNBEventName.clickTab, { button_text: tab.label });

    router.push({ pathname: '/', query: { tab: tab.value } }, undefined, {
      shallow: true,
    });
  };

  return (
    <Tabs
      value={activeTab}
      aria-label="navigation tab"
      role={'navigation'}
      centered
      sx={{
        marginTop: '4px',
        '& .MuiTabs-indicator': { display: 'none' },
      }}
    >
      {tabs.map((item) => (
        <Tab
          key={item.value}
          label={item.label}
          sx={{
            minWidth: 'auto',
            minHeight: '40px',
            height: '40px',
            fontWeight: 500,
            fontSize: '20px',
            color: 'var(--dk-text-dim, #B7BBC2)',
            verticalAlign: 'top',
            padding: 0,
            '&:not(:first-of-type)': {
              marginLeft: '32px',
            },
            '&:hover': {
              color: 'var(--dk-text-dim, #B5B5C3)',
            },
            '&.Mui-selected': {
              color: 'var(--dk-text, black)',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '0',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '6px',
                height: '6px',
                backgroundColor: '#000000',
                borderRadius: '50%',
              },
            },
          }}
          onClick={() => onClickTab(item)}
          disableRipple
        />
      ))}
    </Tabs>
  );
};

export default GNBTab;
